import Notification from '../../../components/Notification';
import { HashLink as Link } from "react-router-hash-link";
import { FormattedMessage } from 'react-intl';

const { id: module_id } = module;

export default function ({ setVisibility, isInboxActive, fetching }) {
  return (
    <Notification className={'primary-green center'}>
      <div className="floating-close" onClick={() => setVisibility(false)}>
        &#x2715;
      </div>
      <p>
        <FormattedMessage id={`${module_id}.info.header`} />
      </p>
      <span>
        <FormattedMessage
          id={`${module_id}.info.location`}
          values={{
            Link: (chunks) => <Link to="/userinfo#userinfo-request">{chunks}</Link>,
          }}
        />
      </span>
      {fetching ? (
        <></>
      ) : isInboxActive ? (
        <ActiveSfiMessage />
      ) : (
        <InactiveSfiMessage />
      )}
    </Notification>
  );
}

const InactiveSfiMessage = () => (
  <>
    <span>
      <FormattedMessage
        id={`${module_id}.info.sfi.deactive`}
        values={{
          a: (chunks) => (
            <a href="https://www.suomi.fi/viestit" target="_blank">
              {chunks}
            </a>
          ),
          icon: (chunks) => (
            <i className="icon-external-link fa ot-icon ot-icon--blue">{chunks}</i>
          ),
        }}
      />
    </span>
    <div className="mt-1">
      <p className="ot-notification__button">
        <FormattedMessage
          id={`${module_id}.info.sfi.activate`}
          values={{
            a: (chunks) => (
              <a
                id="suomifi-viestit-activation__button"
                href="https://www.suomi.fi/viestit"
                target="_blank"
              >
                {chunks}
              </a>
            ),
            icon: (chunks) => (
              <i className="icon-external-link fa ot-icon">{chunks}</i>
            ),
          }}
        />
      </p>
    </div>
  </>
);

const ActiveSfiMessage = () => (
  <p>
    <FormattedMessage
      id={`${module_id}.info.sfi.active`}
      values={{
        a: (chunks) => (
          <a href="https://www.suomi.fi/viestit" target="_blank">
            {chunks}
          </a>
        ),
        icon: (chunks) => (
          <i className="icon-external-link fa ot-icon ot-icon--blue">{chunks}</i>
        ),
      }}
    />
  </p>
);
